module.exports = __webpack_public_path__ + "img/F - 03.dc9d96f6.png";